import { render, staticRenderFns } from "./PropertyOptionList.vue?vue&type=template&id=69b2b9db&"
import script from "./PropertyOptionList.vue?vue&type=script&lang=js&"
export * from "./PropertyOptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports